import arrowLeft from "@assets/images/arrow-left-back.svg";
import plus from "@assets/images/plus.svg";
import { Button, Grid } from "@material-ui/core";
import Container from "@saleor/components/Container";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import { Tab, TabContainer } from "@saleor/components/Tab";
import {
  CustomerMaterialsQuery,
  useExportCustomerMaterialTemplateMutation
} from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import { useFormik } from "formik";
import React, { useMemo, useState } from "react";
import InlineSVG from "react-inlinesvg";
import { FormattedMessage, useIntl } from "react-intl";
import * as Yup from "yup";

import DialogAddMaterial from "../components/DialogAddMaterial/DialogAddMaterial";
import DialogAddMatSuccess from "../components/DialogAddMatSuccess/DialogAddMatSuccess";
import DialogSuccess from "../components/DialogSuccess";
import DialogWaitingConfirm from "../components/DialogWaitingConfirm/DialogWaitingConfirm";
import DialogDownloadWarning from "../components/DialogWarning/DialogDownloadWarning";
import useDownloadExcel from "../components/DownloadExcelFile/DownloadExcelFile";
import DownloadExcelTemplate from "../components/DownloadExcelTemplate";
import EditMaterial from "../components/EditMaterial";
import MaterialFilter from "../components/Materialfilter";
import CustomerMaterialUploadFile from "../components/MaterialUploadFile";
import TableEditMaterial from "../components/TableEditMaterial";
import { ContentHeaderTab } from "../const";

const useStyles = makeStyles(
  theme => ({
    boxContainer: {
      paddingBottom: "6rem"
    },
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        margin: 0,
        marginBottom: "1.2rem"
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    },
    filterUploadBox: {
      display: "grid",
      gap: "30px",
      gridTemplateColumns: "50% auto",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column"
      }
    },
    button: {
      display: "flex",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        "& button": {
          margin: "10px 0"
        }
      }
    },
    btn: {
      // minWidth: 132,
      maxHeight: 40,
      // marginLeft: 16,
      padding: "8px 20px",
      "& .MuiButton-startIcon": {
        marginRight: 0
      },
      "& .MuiTypography-root": {
        color: "inherit"
      }
    },
    btnTxt: {
      lineHeight: "22px",
      fontSize: "14px"
    },
    tabBox: {
      "&>span:first-child": {
        borderRadius: "12px 0 0 0"
      },
      "&>span:last-child": {
        borderRadius: "0 12px 0 0"
      }
    },
    tab: {
      padding: "10px 0",
      textAlign: "center"
    },
    tabContainer: {
      borderBottom: `unset`
    },
    btnBlack: {
      height: 48,
      backgroundColor: "#000000 !important",
      padding: "8px 20px",
      "& .MuiButton-startIcon": {
        marginRight: 0
      },
      "& .MuiTypography-root": {
        color: "inherit"
      },
      "&:hover": {
        backgroundColor: "#2b2b2bff"
      }
    },
    btnTxtWhite: {
      lineHeight: "22px",
      fontSize: "14px",
      color: "#FFFFFF !important"
    }
  }),
  { name: "CustomerMaterialView" }
);

const CustomerMaterialView = () => {
  const classes = useStyles();
  const intl = useIntl();
  const [records, setRecords] = useState("");
  const [editedRecords, setEditedRecords] = useState<CustomerMaterialsQuery>(
    null
  );

  const textError = intl.formatMessage({
    defaultMessage: "โปรดระบุข้อมูล"
  });

  const MaterialFilterSchema = Yup.object().shape({
    soldTo: Yup.string().required(textError),
    saleOrganization: Yup.string().required(textError),
    distributionChannel: Yup.string().required(textError)
  });

  const formik = useFormik({
    initialValues: {
      soldTo: "",
      saleOrganization: "",
      distributionChannel: "",
      soldToMaterialCode: "",
      materialCode: ""
    },
    validationSchema: MaterialFilterSchema,
    onSubmit: () => {
      //
    }
  });

  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [openDialogSucess, setOpenDialogSucess] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const [downloadDisable, setDownloadDisable] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState(ContentHeaderTab.downloadUpload);
  const [
    exportCustomerMaterialTemplate
  ] = useExportCustomerMaterialTemplateMutation();
  const [openAddDialog, setOpenAddDialog] = useState<boolean>(false);
  const [openProcessDialog, setOpenProcessDialog] = useState<boolean>(false);
  const [openAddSuccess, setOpenAddSuccess] = useState(false);
  const [isAddCustomerMat, setIsAddCustomerMat] = useState(false);

  const { downloadExcelFile } = useDownloadExcel({
    formik,
    setOpenWarningDialog,
    openWarningDialog
  });

  const onUpload = () => {
    setOpenUploadFile(true);
  };

  const onUploadSuccess = () => {
    setOpenDialogSucess(true);
  };

  const onClose = () => {
    setResetFilter(true);
    setOpenDialogSucess(false);
  };

  const onReset = () => {
    setOpenUploadFile(false);
    setResetFilter(false);
  };

  const HeaderTab = Tab(ContentHeaderTab.downloadUpload);
  const ItemDetailTab = Tab(ContentHeaderTab.editAdd);

  const isDownloadUploadSection = useMemo(
    () => activeTab === ContentHeaderTab.downloadUpload,
    [activeTab]
  );

  const handleAddMaterial = items => {
    setIsAddCustomerMat(true);
    if (items.length) {
      const records = {
        customerMaterials: items
      };
      setEditedRecords(records as CustomerMaterialsQuery);
    }
    setOpenAddDialog(false);
    setOpenAddSuccess(true);
  };

  return (
    <>
      <Container className={classes.boxContainer}>
        <PageHeader
          className={classes.pageHeader}
          title={"Maintain"}
          subTitle={" - Customer Material"}
        />

        <TabContainer className={classes.tabContainer}>
          <div className={classes.tabBox}>
            <HeaderTab
              testId="downloadUpload-tab"
              isActive={activeTab === ContentHeaderTab.downloadUpload}
              changeTab={() => setActiveTab(ContentHeaderTab.downloadUpload)}
            >
              <MyTypography variant="h6" className={classes.tab}>
                {intl.formatMessage({
                  defaultMessage: ContentHeaderTab.downloadUpload
                })}
              </MyTypography>
            </HeaderTab>
            <ItemDetailTab
              testId="editAdd-tab"
              isActive={activeTab === ContentHeaderTab.editAdd}
              changeTab={() => setActiveTab(ContentHeaderTab.editAdd)}
            >
              <MyTypography variant="h6" className={classes.tab}>
                {intl.formatMessage({
                  defaultMessage: ContentHeaderTab.editAdd
                })}
              </MyTypography>
            </ItemDetailTab>
          </div>
        </TabContainer>

        <Grid container spacing={3}>
          {activeTab === ContentHeaderTab.downloadUpload && (
            <Grid item xs={12} md={6}>
              <MaterialFilter
                formik={formik}
                onReset={onReset}
                onUpload={onUpload}
                onDownload={downloadExcelFile}
                resetFilter={resetFilter}
                downloadDisable={downloadDisable}
                setDownloadDisable={setDownloadDisable}
              />
            </Grid>
          )}
          {activeTab === ContentHeaderTab.editAdd && (
            <Grid item xs={12} md={12}>
              <EditMaterial
                formik={formik}
                onReset={() => {
                  onReset();
                  setEditedRecords(null);
                }}
                resetFilter={resetFilter}
                setDownloadDisable={setDownloadDisable}
                handleSearchData={data => {
                  setIsAddCustomerMat(false);
                  if (data?.customerMaterials.length > 0) {
                    setEditedRecords(data);
                  } else {
                    setEditedRecords(null);
                  }
                }}
              />
            </Grid>
          )}
          {openUploadFile && isDownloadUploadSection && (
            <Grid item xs={12} md={6}>
              <CustomerMaterialUploadFile
                formik={formik}
                onUploadSuccess={onUploadSuccess}
                setRecords={setRecords}
              />
            </Grid>
          )}
          {!openUploadFile && isDownloadUploadSection && (
            <Grid item xs={12} md={12}>
              <DownloadExcelTemplate
                onDownloadPdf={exportCustomerMaterialTemplate}
              />
            </Grid>
          )}

          {openUploadFile && isDownloadUploadSection && (
            <Grid item xs={12} md={12}>
              <div className={classes.button}>
                <Button
                  variant="outlined"
                  className={classes.btn}
                  onClick={() => {
                    setOpenUploadFile(false);
                    setDownloadDisable(false);
                  }}
                  startIcon={<InlineSVG src={arrowLeft} />}
                  id="back"
                  name="back"
                >
                  <MyTypography variant="button3" className={classes.btnTxt}>
                    <FormattedMessage defaultMessage=" Back" />
                  </MyTypography>
                </Button>
              </div>
            </Grid>
          )}

          {openWarningDialog && (
            <DialogDownloadWarning
              onConfirm={() => setOpenWarningDialog(false)}
              open={openWarningDialog}
            />
          )}

          {!isDownloadUploadSection && (
            <Grid item xs={12} md={12}>
              <div className={classes.button}>
                <Button
                  variant="contained"
                  className={classes.btnBlack}
                  onClick={() => setOpenAddDialog(true)}
                  startIcon={<InlineSVG src={plus} />}
                  id="back"
                  name="back"
                >
                  <MyTypography
                    variant="button3"
                    className={classes.btnTxtWhite}
                  >
                    <FormattedMessage defaultMessage=" Add Customer Material" />
                  </MyTypography>
                </Button>
              </div>
            </Grid>
          )}

          {!isDownloadUploadSection && editedRecords && (
            <TableEditMaterial
              tableData={editedRecords}
              isAddCustomerMat={isAddCustomerMat}
              onUpdateTableData={updatedData => {
                setIsAddCustomerMat(false);
                setEditedRecords(updatedData);
              }}
            />
          )}

          {!isDownloadUploadSection && openAddDialog && (
            <DialogAddMaterial
              open={openAddDialog}
              onConfirm={data => {
                handleAddMaterial(data);
              }}
              onClose={() => {
                setOpenAddDialog(false);
              }}
            />
          )}
          {openProcessDialog && (
            <DialogWaitingConfirm
              open={openProcessDialog}
              onClose={() => setOpenProcessDialog(false)}
            />
          )}

          {openAddSuccess && (
            <DialogAddMatSuccess
              open={openAddSuccess}
              onClose={() => setOpenAddSuccess(false)}
            />
          )}
        </Grid>
      </Container>

      <DialogSuccess
        isOpen={openDialogSucess}
        onClose={onClose}
        records={records}
      />
    </>
  );
};

export default CustomerMaterialView;
